// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@1,700&family=Poppins:wght@300&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Poppins", sans-serif;
  background-color: #090930;
}

#header {
  font-weight: 700;
  color: #090930;
}

.task--wrapper {
  padding: 0;
}
@media (min-width: 768px) {
  .task--wrapper {
    width: 60%;
  }
}

input[type=text] {
  outline: none;
}
input[type=text]::placeholder {
  font-style: italic;
}

input[type=checkbox] {
  transition: all 0.2s ease-in-out;
}
input[type=checkbox]:checked {
  accent-color: #2ecd2e;
}
input[type=checkbox]:hover {
  transform: scale(1.2);
}

.my-button {
  background-color: #fff;
  color: #8f8f8f;
  border: none;
  transition: all 0.2s ease-in-out;
}
.my-button.clear-all {
  background-color: #e2e2e2;
}
.my-button.draggable {
  cursor: move;
}
.my-button.trash:hover {
  color: #8f2727;
}
.my-button:hover {
  color: #555;
}

.task-completed {
  text-decoration: line-through;
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/styles/index.scss"],"names":[],"mappings":"AAOA;EACE,kCAAA;EACA,yBAJU;AADZ;;AAQA;EACE,gBAAA;EACA,cATU;AAIZ;;AAQA;EACE,UAAA;AALF;AAOE;EAHF;IAII,UAAA;EAJF;AACF;;AAOA;EACE,aAAA;AAJF;AAME;EACE,kBAAA;AAJJ;;AAQA;EACE,gCAAA;AALF;AAOE;EACE,qBAAA;AALJ;AAQE;EACE,qBAAA;AANJ;;AAUA;EACE,sBA5CkB;EA6ClB,cA5CkB;EA6ClB,YAAA;EACA,gCAAA;AAPF;AASE;EACE,yBAAA;AAPJ;AAUE;EACE,YAAA;AARJ;AAWE;EACE,cAAA;AATJ;AAYE;EACE,WA5DuB;AAkD3B;;AAcA;EACE,6BAAA;EACA,YAAA;AAXF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@1,700&family=Poppins:wght@300&display=swap');\n\n$button-background: #fff;\n$button-font-color: #8f8f8f;\n$button-darker-font-color: #555;\n$dark-blue: #090930;\n\nbody {\n  font-family: 'Poppins', sans-serif;\n  background-color: $dark-blue;\n}\n\n#header {\n  font-weight: 700;\n  color: $dark-blue;\n}\n\n.task--wrapper {\n  padding: 0;\n\n  @media (min-width: 768px) {\n    width: 60%;\n  }\n}\n\ninput[type='text'] {\n  outline: none;\n\n  &::placeholder {\n    font-style: italic;\n  }\n}\n\ninput[type='checkbox'] {\n  transition: all 0.2s ease-in-out;\n\n  &:checked {\n    accent-color: #2ecd2e;\n  }\n\n  &:hover {\n    transform: scale(1.2);\n  }\n}\n\n.my-button {\n  background-color: $button-background;\n  color: $button-font-color;\n  border: none;\n  transition: all 0.2s ease-in-out;\n\n  &.clear-all {\n    background-color: #e2e2e2;\n  }\n\n  &.draggable {\n    cursor: move;\n  }\n\n  &.trash:hover {\n    color: #8f2727;\n  }\n\n  &:hover {\n    color: $button-darker-font-color;\n  }\n}\n\n.task-completed {\n  text-decoration: line-through;\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
